// extracted by mini-css-extract-plugin
module.exports = {"customization-title":"formComponents_customization-title__2x4ic"};